import { render, staticRenderFns } from "./IconSvg.vue?vue&type=template&id=5e030185&scoped=true"
import script from "./IconSvg.vue?vue&type=script&lang=js"
export * from "./IconSvg.vue?vue&type=script&lang=js"
import style0 from "./IconSvg.vue?vue&type=style&index=0&id=5e030185&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e030185",
  null
  
)

export default component.exports